var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-screen',{attrs:{"isAuth":this.$store.state.auth.authorization,"isOpenSidebar":this.$store.state.app.sidebarOpen,"isOpenReportGroupModal":this.$store.state.report.openReportGroupModal},on:{"logout":_vm.handleOnLogout}})}
var staticRenderFns = []

export { render, staticRenderFns }